module.exports = __webpack_public_path__ + "img/bankgaransi.c9615e46.jpg";